import clearCache from 'Menu/services/api/braincube';

import modifyUserPreference from './api/preferences';

const iOs = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);

export { clearCache, modifyUserPreference, iOs };
